/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Meta_Count_PlayersInputs */



/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{countFormatted} player" |
* | * | "{countFormatted} players" |
*
* @param {Meta_Count_PlayersInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const meta_count_players = /** @type {((inputs: Meta_Count_PlayersInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Count_PlayersInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") {
		const countPlural = registry.plural("de", i?.count, {}, true);
		const countFormatted = registry.number("de", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`${countFormatted} Spieler`);
		return /** @type {LocalizedString} */ (`${countFormatted} Spieler`)
	}
	if (locale === "fr") {
		const countPlural = registry.plural("fr", i?.count, {}, true);
		const countFormatted = registry.number("fr", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`${countFormatted} joueur`);
		return /** @type {LocalizedString} */ (`${countFormatted} joueurs`)
	}
	if (locale === "zh-Hans") {
		const countPlural = registry.plural("zh-Hans", i?.count, {}, true);
		const countFormatted = registry.number("zh-Hans", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`${countFormatted}名选手`);
		return /** @type {LocalizedString} */ (`${countFormatted}名选手`)
	}
	if (locale === "zh-Hant") {
		const countPlural = registry.plural("zh-Hant", i?.count, {}, true);
		const countFormatted = registry.number("zh-Hant", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`${countFormatted} 位玩家`);
		return /** @type {LocalizedString} */ (`${countFormatted} 位玩家`)
	}
	if (locale === "ko") {
		const countPlural = registry.plural("ko", i?.count, {}, true);
		const countFormatted = registry.number("ko", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`플레이어 ${countFormatted}명`);
		return /** @type {LocalizedString} */ (`플레이어 ${countFormatted}명`)
	}
	{
		const countPlural = registry.plural("en", i?.count, {}, true);
		const countFormatted = registry.number("en", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`${countFormatted} player`);
		return /** @type {LocalizedString} */ (`${countFormatted} players`)
	}
});